import { Injectable } from '@angular/core';
import { createFrom, EventService, Product, ProductService } from '@spartacus/core';
import { NavigationEvent } from '@spartacus/storefront';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { GtmGgProductPageEvent } from './gtm-gg-product-page-event';

@Injectable({
  providedIn: 'root',
})
export class GtmGgProductPageEventBuilder {
  constructor(
    private eventService: EventService,
    private productService: ProductService
  ) {
    const gtmGgProductPageEventSource = this.eventService.get(NavigationEvent).pipe(
      filter((navigationEvent) => navigationEvent.semanticRoute === 'product'),
      switchMap((navigationEvent) =>
        this.productService.get(navigationEvent.context.id).pipe(
          filter((product) => Boolean(product)),
          take(1),
          map((product) =>
            createFrom(GtmGgProductPageEvent, {
              event: 'product-detail',
              ecommerce: {
                detail: {
                  actionField: {},
                  products: [
                    {
                      name: product?.name || '',
                      price: product?.price?.value ? product.price.value.toString() : '',
                      category: product
                        ? this.getCategoriesFromProduct(product).substring(
                            this.getCategoriesFromProduct(product).indexOf(',') + 1
                          )
                        : undefined,
                      id: product?.code || '',
                      variant: product?.variantType || '',
                      brand: product?.manufacturer || '',
                    },
                  ],
                },
              },
            })
          )
        )
      )
    );

    eventService.register(GtmGgProductPageEvent, gtmGgProductPageEventSource);
  }

  getCategoriesFromProduct(product: Product) {
    let categories = '';

    product.categories?.forEach((category) => {
      categories = categories + ',' + category.name;
    });

    return categories;
  }
}
